// extracted by mini-css-extract-plugin
module.exports = {"cherryInfoWrapper":"ClientCherryInfo_cherryInfoWrapper__QESx9","title":"ClientCherryInfo_title__388xS","itemText":"ClientCherryInfo_itemText__3AANU"};